import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import google from "../../images/google-icon.svg";
import { SIGN_UP_VERIFY } from "../../mutation/SignUpVerify";
import { useMutation } from "@apollo/react-hooks";
import SignUpSvg from "../Common/SignUpSvg";

const SignupVerify = (props) => {
  const history = useHistory();
  const { id } = props.match.params;
  const token = id;

  const [SignUpVerify] = useMutation(SIGN_UP_VERIFY);
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => {
    if (token) {
      SignUpVerify({
        variables: {
          id: token,
        },
      })
        .then((response) => {
          history.push("/verified-account");
        })
        .catch((e) => {
          const errors = e.graphQLErrors;
          setErrorMessage(errors[0].message);
        });
    }
  }, []);

  return (
    <div className="signupfulllayout">
      <div className="signup-logo">
        <SignUpSvg />
      </div>
      <div className="lg-right signupverify-main">
        <div className="login-cover signupverify-box">
          <div className="login-box">
            {errorMessage ? errorMessage : null}

            <h2>Great your account is verified!</h2>
            <p>Let’s start build your profile.</p>
            <div className="login-type">
              <Link to="#">
                <span className="icon">
                  <img src={google} alt="login with google" />
                </span>
                Import Google Business/Club profile
              </Link>
              <Link to="/build-profile">Create profile manually</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupVerify;
